import { Extension } from '@tiptap/core';

const TARGET_TYPES = ['paragraph', 'heading'];

const normalizeSpacing = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  return Math.max(0, Math.min(48, Math.round(numeric)));
};

const parseSpacing = (element) => {
  const fromData = element?.getAttribute?.('data-paragraph-spacing');
  const classAttr = element?.getAttribute?.('class') || '';
  const classMatch = String(classAttr).match(/paragraph-spacing-(\d{1,2})/);
  const raw = fromData || (classMatch ? classMatch[1] : '') || element?.style?.marginBottom || '';
  const match = String(raw).match(/-?\d+(\.\d+)?/);
  if (!match) return null;
  return normalizeSpacing(match[0]);
};

const setSpacingForSelection = (state, dispatch, spacing) => {
  const { from, to, empty } = state.selection;
  const targetTypes = TARGET_TYPES
    .map((name) => state.schema.nodes[name])
    .filter(Boolean);
  if (!targetTypes.length) return false;

  let tr = state.tr;
  let changed = false;
  const isTargetType = (type) => targetTypes.some((targetType) => targetType === type);

  state.doc.nodesBetween(from, to, (node, pos) => {
    if (!isTargetType(node.type)) return;
    tr = tr.setNodeMarkup(pos, node.type, { ...node.attrs, paragraphSpacing: spacing }, node.marks);
    changed = true;
  });

  if (!changed && empty) {
    const { $from } = state.selection;
    for (let depth = $from.depth; depth > 0; depth -= 1) {
      const node = $from.node(depth);
      if (!isTargetType(node.type)) continue;
      const pos = $from.before(depth);
      tr = tr.setNodeMarkup(pos, node.type, { ...node.attrs, paragraphSpacing: spacing }, node.marks);
      changed = true;
      break;
    }
  }

  if (!changed) return false;
  if (dispatch) dispatch(tr);
  return true;
};

const ParagraphSpacingExtension = Extension.create({
  name: 'paragraphSpacing',

  addGlobalAttributes() {
    return [
      {
        types: TARGET_TYPES,
        attributes: {
          paragraphSpacing: {
            default: null,
            parseHTML: parseSpacing,
            renderHTML: (attributes) => {
              const spacing = normalizeSpacing(attributes?.paragraphSpacing);
              if (spacing === null) return {};
              return {
                class: `paragraph-spacing-${spacing}`,
                'data-paragraph-spacing': String(spacing),
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setParagraphSpacing:
        (value) =>
        ({ state, dispatch }) =>
          setSpacingForSelection(state, dispatch, normalizeSpacing(value)),
      unsetParagraphSpacing:
        () =>
        ({ state, dispatch }) =>
          setSpacingForSelection(state, dispatch, null),
    };
  },
});

export default ParagraphSpacingExtension;
